import Typography from "@mui/material/Typography";
import React, { FC } from "react";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { COLOR_WHITE } from "shared/theme/colors";
import { StyledCountIndicator, StyledLoadingCountIndicator } from "./styled";

type Props = {
  label: string;
  indicatorShown: boolean;
  indicatorCount: number;
  indicatorLoading?: boolean;
};

const TabWithIndicator: FC<Props> = (props) => {
  const renderLoadingIndicator = () => (
    <StyledLoadingCountIndicator justifyContent="center"/>
  );

  const renderCountIndicator = () => (
    <StyledCountIndicator justifyContent="center">
      <Typography variant="bodyXSSemiBold" color={COLOR_WHITE}>
        {props.indicatorCount}
      </Typography>
    </StyledCountIndicator>
  );

  return (
    <FlexCenter gap="0.5rem">
      {props.label}
      {props.indicatorLoading ? renderLoadingIndicator() : null}
      {props.indicatorShown && !props.indicatorLoading && renderCountIndicator()}
    </FlexCenter>
  );
};

export default TabWithIndicator;
